module.exports = __webpack_public_path__ + "static/screenshotbutton-abfa1d765de421e692b88a2ba10655bb.png";